import React from 'react';

const AiBadgeIcon = ({ size = 18, color = '#2563eb', className = '', title = 'Yara AI' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 34 34"
    className={className}
    role="img"
    aria-label={title}
  >
    {title ? <title>{title}</title> : null}
    <rect
      x="2"
      y="8"
      width="22"
      height="22"
      rx="6"
      fill="none"
      stroke={color}
      strokeWidth="2.4"
    />
    <text
      x="13"
      y="24"
      textAnchor="middle"
      fontFamily="Arial, Helvetica, sans-serif"
      fontWeight="800"
      fontSize="11"
      fill={color}
    >
      AI
    </text>
    <path
      d="M26 2 Q26.9 5.1 30 6 Q26.9 6.9 26 10 Q25.1 6.9 22 6 Q25.1 5.1 26 2 Z"
      fill={color}
    />
    <path
      d="M31 9 Q31.5 10.5 33 11 Q31.5 11.5 31 13 Q30.5 11.5 29 11 Q30.5 10.5 31 9 Z"
      fill={color}
    />
  </svg>
);

export default AiBadgeIcon;
